var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "1200" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("summary-edit-row")))]),
      _c(
        "w-scroll-view",
        {
          attrs: {
            tag: "w-sortable",
            "tag-attributes": _vm.sortableAttributes,
          },
        },
        [
          _vm._l(_vm.row.Cols, function (item) {
            return _c(
              "w-list-item",
              { key: item.uid, attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [
                  _vm._v(_vm._s(item.getText(_vm.model))),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("summary-edit-col"),
                            expression: "$ct('summary-edit-col')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editCol(item)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("summary-delete-col"),
                            expression: "$ct('summary-delete-col')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.deleteCol(item)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.addCol()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(_vm._s(_vm.$ct("summary-add-col"))),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditIndex != -1 } },
        [
          _vm.toEditIndex != -1
            ? _c("app-summary-edit-col", {
                attrs: { model: _vm.model },
                on: {
                  close: function ($event) {
                    _vm.toEditIndex = -1
                  },
                },
                model: {
                  value: _vm.row.Cols[_vm.toEditIndex],
                  callback: function ($$v) {
                    _vm.$set(_vm.row.Cols, _vm.toEditIndex, $$v)
                  },
                  expression: "row.Cols[toEditIndex]",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }